import $$ from 'cmn-utils'

const baseUrl = "/api/prospect/task-item/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    result:(params) =>{
        return $$.get(baseUrl + 'result/list',params)
    }
}